import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { RECENT_SEARCH_PROP_TYPES } from '../model/types';
import { HomepageRecentSearches } from './HomepageRecentSearches';

export const RecentSearchesContainer = ({ recentSearches = [], trackRecentSearchClick }) => {
  const [recentSearchesState, setRecentSearchesState] = useState(recentSearches);

  return (
    <HomepageRecentSearches
      recentSearches={recentSearchesState}
      trackRecentSearchClick={trackRecentSearchClick}
      setRecentSearchesState={setRecentSearchesState}
    />
  );
};

RecentSearchesContainer.propTypes = {
  recentSearches: RECENT_SEARCH_PROP_TYPES,
  trackRecentSearchClick: PropTypes.func.isRequired,
};

export default RecentSearchesContainer;
